import { SMC } from '@andywilliams/indicators';
import { bandTimeframe } from '../features/markets/cycleWindowBand';

// DWLF-336 (indicators 16): the SMC library cannot see the timeframe, so the
// chart tells weekly detection its own zone expiry age, the one the jobs store
// weekly events under. Daily and hourly keep the library default.
export const smcOptionsFor = (timeframeKey) => (bandTimeframe(timeframeKey) === 'weekly'
  ? { maxAgeBars: SMC.SMC_MAX_AGE_BARS.weekly }
  : undefined);

// A gap still drawn to the live edge: neither filled (a close through its far
// edge) nor expired by age. A wick that takes half of it is a test, not a fill.
export const fvgIsLive = (gap) => gap?.state === 'open' || gap?.state === 'partial';

// The bar a gap was filled on, the `smc.fvg.filled` event's own bar, or null.
export const fvgFill = (gap) => (gap?.state === 'filled'
  && Number.isInteger(gap.fillIndex) && Number.isFinite(gap.fillTime)
  ? { index: gap.fillIndex, time: gap.fillTime }
  : null);
